import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector", "firstInput", "secondInput", "result"]

  connect() {
    this.render()
  }

  selectDate(event) {
    const value = event.target.value
    if (!value) return

    if (!this.firstInputTarget.value) {
      this.firstInputTarget.value = value
    } else if (!this.secondInputTarget.value) {
      this.secondInputTarget.value = value
    }

    event.target.value = ""
    this.render()
  }

  removeFirst() {
    this.firstInputTarget.value = ""
    this.render()
  }

  removeSecond() {
    this.secondInputTarget.value = ""
    this.render()
  }

  render() {
    const first = this.firstInputTarget.value
    const second = this.secondInputTarget.value
    const selected = [first, second].filter(Boolean)
    const full = selected.length >= 2

    // バッジを再生成
    this.resultTarget.innerHTML = ""
    if (first) this.resultTarget.appendChild(this.createBadge("First", "第一希望", first, true))
    if (second) this.resultTarget.appendChild(this.createBadge("Second", "第二希望", second, false))

    // セレクトの各オプションを更新
    Array.from(this.selectorTarget.options).forEach(opt => {
      if (!opt.value) return
      opt.disabled = full || selected.includes(opt.value)
      opt.style.color = opt.disabled ? "#9CA3AF" : ""
    })

    this.selectorTarget.disabled = full
    this.selectorTarget.style.opacity = full ? "0.5" : "1"
  }

  createBadge(which, label, value, isFirst) {
    const dateLabel = this.getLabelForValue(value)
    const span = document.createElement("span")
    span.className = isFirst
      ? "inline-flex items-center gap-1 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 px-3 py-1 rounded-full"
      : "inline-flex items-center gap-1 text-sm font-medium text-green-700 bg-green-50 border border-green-200 px-3 py-1 rounded-full"
    span.appendChild(document.createTextNode(`${label}：${dateLabel}`))

    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "ml-1 text-gray-400 hover:text-gray-600"
    btn.textContent = "✕"
    btn.setAttribute("data-action", `click->intern-date-selector#remove${which}`)
    span.appendChild(btn)

    return span
  }

  getLabelForValue(value) {
    const opt = Array.from(this.selectorTarget.options).find(o => o.value === value)
    return opt ? opt.textContent.trim() : value
  }
}
